class TopVideoPlayer {

    constructor() {
            this.videoLinks = document.querySelectorAll('.top-videos-player .top-videos-player-link');

            this.addClickListeners();
        } // constructor

    getPlayerVideoTitle() {

            let playerVideoTitleElm = document.querySelector('.titlebar_fg .title');
            if (playerVideoTitleElm !== null) {
                return playerVideoTitleElm.innerHTML;
            }
            return null;

        } // getPlayerVideoTitle()


    updateTopVideoPlayer(event) {

            event.preventDefault();

            let elem = event.currentTarget;
            let releaseUrl = elem.getAttribute('data-release') + elem.getAttribute('data-iu');

            if (fdmPlayer !== 'undefined' && fdmPlayer instanceof Array) {

                fdmPlayer[0].setReleaseCall(releaseUrl);
            }

        } // updateTopVideoPlayer()

    addClickListeners() {

            let videos = this.videoLinks;
            let count = videos.length;

            for (let i = 0; i < count; i += 1) {
                videos[i].addEventListener('click', this.updateTopVideoPlayer.bind(this));
            }

        } // addClickListeners()

} // TopVideoPlayer

export default TopVideoPlayer;